<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";

// Editor twin always draws its contents so they stay editable; staging uses the engine's HoverArea.
export default {
  name: "HoverAreaContainer",
  extends: Container,
  elementPanelSettings: {
    alias: "Hover Area",
    displayName: "Hover Area",
    displayIcon: "mdi:cursor-default-click-outline",
    tags: ["container", "hover", "reveal", "row"],
  },
  hidden: true,
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "horizontal",
    }),
    SpacingOptions,
    AppearanceOptions,
  ],
};
</script>
